<template>
    <section class="plugin-home-tabs">
        <div class="plugin-home-tabs__container">
            <div class="plugin-home-tabs__link">
                <plugin-home-common-arrow-link
                    v-bind:text="buttonText"
                    v-bind:url="buttonUrl"
                />
            </div>

            <plugin-home-common-title v-bind:text="title" />

            <div class="plugin-home-tabs__subtitle"
                 v-if="subtitle"
            >
                {{ subtitle }}
            </div>

            <div class="plugin-home-tabs__buttons">
                <div class="plugin-home-tabs__buttons-item"
                     v-for="item in items"
                     v-bind:key="item.id"
                >
                    <ui-button
                        v-bind:text="item.menuTitle"
                        v-bind:theme="item.id === activeId ? 'secondary-2a' : 'bordered-2'"
                        v-bind:size="isMobile ? 'md' : 'lg'"
                        v-bind:is-uppercase="false"
                        v-on:click="activeId = item.id"
                        is-width-free
                    />
                </div>
            </div>

            <div class="plugin-home-tabs__content">
                <slot v-bind:active-id="activeId" />
            </div>
        </div>
    </section>
</template>

<script>
// import utils from '~/utils';

export default {
    name: 'plugin-home-tabs',
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: '',
        },
        buttonUrl: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        activeId: null,
    }),
    computed: {
        isMobile() {
            return window.innerWidth < 768;
        },
    },
    methods: {

    },
    mounted() {
        this.activeId = this.items[0].id;
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-tabs {
    .container-landing();

    &__container {
        max-width: @landing-max-width;
        margin: 0 auto;
    }
    &__subtitle {
        .typography-medium();

        margin: 0 auto;
        margin-bottom: 48px;
        max-width: 940px;
        text-align: center;
    }
    &__link {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
    }
    &__buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        padding-bottom: 8px;
        margin-bottom: 40px;
        overflow-x: auto;
        &-item {
            flex-shrink: 0;
            width: 100%;
            max-width: 330px;
        }
    }
    &__content {
        width: 100%;
    }
    @media @media-md-down {
        &__subtitle {
            .typography-heading();

            margin: 0;
            margin-bottom: 32px;
            text-align: left;
        }
        &__link {
            justify-content: flex-start;
        }
        &__buttons {
            justify-content: flex-start;
            margin-bottom: 16px;
        }
    }
}
</style>
